import { BLACK, BLACK_100, BLACK_500, BLACK_700, BLACK_800, BLACK_900, BLUE_100, BLUE_200, BLUE_400, BLUE_500, BLUE_600, TRANSPARENT } from '../colors';
var tabConfig = {
  text: '',
  type: 'tab',
  size: 'md',
  selected: false,
  showNotifier: false,
  controlState: 'none',
  config: {
    type: {
      tab: {
        borderBottomWidth: 2,
        selectionState: {
          default: {
            controlStates: {
              none: {
                color: BLACK_700,
                borderColor: TRANSPARENT
              },
              disabled: {
                color: BLACK_500,
                borderColor: TRANSPARENT
              },
              hover: {
                color: BLACK_800,
                borderColor: BLACK_800
              },
              pressed: {
                color: BLACK_900,
                borderColor: BLACK_900
              }
            }
          },
          selected: {
            controlStates: {
              none: {
                color: BLACK,
                borderColor: BLACK
              },
              disabled: {
                color: BLACK_500,
                borderColor: BLACK_500
              },
              hover: {
                color: BLACK_800,
                borderColor: BLACK_800
              },
              pressed: {
                color: BLACK_900,
                borderColor: BLACK_900
              }
            }
          }
        }
      },
      pill: {
        borderRadius: 'BORDER_RADIUS_7',
        selectionState: {
          default: {
            controlStates: {
              none: {
                color: BLACK_900
              },
              disabled: {
                color: BLACK_500
              },
              hover: {
                color: BLACK_900,
                backgroundColor: BLUE_100
              },
              pressed: {
                color: BLACK_900,
                backgroundColor: BLUE_200
              }
            }
          },
          selected: {
            controlStates: {
              none: {
                color: BLACK_100,
                backgroundColor: BLUE_500
              },
              disabled: {
                color: BLACK_700,
                backgroundColor: BLACK_500
              },
              hover: {
                color: BLACK_100,
                backgroundColor: BLUE_400
              },
              pressed: {
                color: BLACK_100,
                backgroundColor: BLUE_600
              }
            }
          }
        }
      }
    },
    size: {
      md: {
        tab: {
          minHeight: 34,
          paddingHorizontal: 'SPACING_8'
        },
        pill: {
          minHeight: 40,
          paddingHorizontal: 'SPACING_8'
        }
      }
    }
  }
};
export default {
  light: tabConfig,
  dark: tabConfig,
  white: tabConfig
};